import { Module } from "vuex";
import { mutations } from "./mutations";
import { SurveyState } from "./types";
import { RootState } from "../types";
import { SurveyFormDetails } from "@/models/SurveyFormDetails";
import { getters } from "./getters";
import { actions } from "./actions";

export const state: SurveyState = {
  currentSurvey: new SurveyFormDetails(),
  isLoading: true,
  currentSurveyError: null,
  surveyErrors: []
};

const namespaced = true;

// Survey is the module state, RootState is state for Vuex store
export const survey: Module<SurveyState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
